export default __webpack_public_path__ + "static/media/rocket_anim_154.935f8795.png";